import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Docs pages own their own hash-scroll behavior (DocsLayout waits for images
    // to load before scrolling so cross-page anchor jumps land in the right
    // spot). Skip our generic handler there to avoid double-scrolling.
    if (pathname.startsWith('/touchpose/docs')) return;

    if (hash) {
      // Small delay to let the page render before scrolling to the element
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
